<template>
    <div class="audit-code-block">
        <div class="audit-code-toolbar">
            <span>{{ languageLabel }}</span>
            <CopyButton
                icon-class="fi-copy"
                :copy-text="code"
                button-class="audit-code-copy"
                tooltip="Copy"
            />
        </div>
        <pre><code>{{ code }}</code></pre>
    </div>
</template>

<script>
import CopyButton from '@/components/fields/CopyButton.vue';

export default {
    name: 'AuditCodeBlock',
    components: { CopyButton },
    props: {
        code: { type: String, default: '' },
        language: { type: String, default: '' },
    },
    computed: {
        languageLabel() {
            return this.language.trim().split(/\s+/)[0] || 'Code';
        },
    },
};
</script>

<style scoped>
.audit-code-block {
    overflow: hidden;
    margin: 0 0 var(--space-3);
    border: 1px solid var(--neutral-600);
    border-radius: var(--radius-default);
    background: var(--neutral-450);
}

.audit-code-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 2.5rem;
    gap: var(--space-3);
    padding: var(--space-1) var(--space-2) var(--space-1) var(--space-3);
    border-bottom: 1px solid var(--neutral-600);
    background: var(--accent-tan-400);
    color: var(--neutral-800);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.audit-code-block pre {
    overflow-x: auto;
    margin: 0;
    padding: var(--space-4);
    background: var(--neutral-400);
}

.audit-code-block code {
    padding: 0;
    background: transparent;
    color: var(--neutral-900);
    font-size: 0.875rem;
    line-height: 1.6;
}

:deep(.audit-code-copy) {
    width: 2rem;
    height: 2rem;
    border-color: transparent;
    background: transparent;
    color: var(--neutral-900);
}

:deep(.audit-code-copy:hover),
:deep(.audit-code-copy:focus-visible) {
    border-color: var(--primary-200);
    background: var(--primary-25);
    color: var(--primary-500);
}
</style>
